import Model from '../Apis/VideoGallery.js'
import Controller from './Controller.js';

export default class VideoGalleryController extends Controller {

    constructor() {
        super(new Model());
    }


}